import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { DialogsService } from '../../../services/dialogs.service';
import { NotificationsOverlayList } from './notifications-overlay-list.component';

@Directive({ selector: '[openOverlayListPageEvent]' })

// createOpenPageEvent
export class NotificationsOverlayListDirective {

    /**
     * Directive for manipule event to Open Overlay-list
     */
    constructor(
        private _el: ElementRef,
        private _r: Renderer2,
        // private _rT: Router,
        private dialogsService: DialogsService
    ) {
        _r.listen(_el.nativeElement, 'click', () => {
            this.dialogsService.showComponnent( NotificationsOverlayList );
        });
    }
}